import "core-js/modules/es.array.map.js";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Stack from 'components/Stack';
import Text from 'components/Text';
import BulletList from 'components/BulletList';
import SimpleModal from 'components/SimpleModal';
export default function PlaylistLinkPermissionModal(_ref) {
  var onClose = _ref.onClose,
    onSubmit = _ref.onSubmit,
    playlistNames = _ref.playlistNames;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    title: t('modal_optional_content_title'),
    body: /*#__PURE__*/React.createElement(Stack, {
      spacing: "m"
    }, /*#__PURE__*/React.createElement(Text, {
      as: "p"
    }, t('modal_playlist_link_permission_message_1')), /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "modal_playlist_link_permission_message_2"
    }, "If you add them as ", /*#__PURE__*/React.createElement("strong", null, "required"), " then they will inherit the parent`'`s permissions."), /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "modal_playlist_link_permission_message_3"
    }, "Adding them as ", /*#__PURE__*/React.createElement("strong", null, "optional"), " won`'`t inherit any permissions and anyone who doesn`'`t have access will not see the playlist."), /*#__PURE__*/React.createElement(BulletList, null, playlistNames.map(function (playlist) {
      return playlist;
    })), /*#__PURE__*/React.createElement(Text, {
      as: "p"
    }, t('modal_how_to_add'))),
    buttons: [{
      label: t('actions_add_as_required'),
      onClick: function onClick() {
        return onSubmit({
          optional: false
        });
      }
    }, {
      label: t('actions_add_as_optional'),
      onClick: function onClick() {
        return onSubmit({
          optional: true
        });
      }
    }],
    onClose: onClose
  });
}